<template>
  <div class="scpPage">
    <div class="operation">
      <div>
      <i-button @click="getServiceInfo">
        <i class="iconfont icon-refresh"></i>
        刷新
      </i-button>
      <i-button @click="showLog = true" style="margin-left: 15px;" type="primary">
        查看日志
      </i-button>
    </div>
      <div style="display: flex;align-items: center;">
      <i-switch
          v-model="isOpen"
          @on-change="changeSwitch"
          size="small"
          style="margin: 8px 20px 0 0px"
        ></i-switch>
      <div class="status">
        {{
          result.serviceStatus == 10
            ? "启 用"
            : result.serviceStatus == 11
            ? "启 用 中"
            : result.serviceStatus == 21
            ? "禁 用 中"
            : "禁 用"
        }}
      </div>
    </div>
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>
        WorkList服务基本信息
      </div>
      <!-- <div style="display: flex; justify-content: space-between">
        <div class="log" @click="showLog = true">查看日志</div>
        <i-switch
          v-model="isOpen"
          @on-change="changeSwitch"
          size="small"
          style="margin: 8px 0 0 0"
        ></i-switch>
      </div> -->
    </div>
    <div class="des">
      <div class="serDes">
        <span class="secondTit">服务描述：</span>{{ result.description }}
      </div>
      <!-- <div>
        <span class="secondTit">更新时间：</span>{{ result.createTime }}
      </div> -->
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>
        基础配置
      </div>
    </div>
    <div class="des">
      <Form :label-width="120" inline>
        <FormItem label="接口地址">
          <Input
            placeholder="请输入"
            v-model="baseData.webAPIAddress"
            clearable
          ></Input>
        </FormItem>

        <FormItem label="是否打印SQL">
          <Radio-group v-model="baseData.printSql">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </Radio-group>
        </FormItem>

        <FormItem label="日志级别">
          <Select v-model="baseData.logLevel" style="width: 190px">
            <Option
              v-for="item in LogsData"
              :value="item.key"
              :key="item.key"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
      </Form>

      <Button class="ml-5 mr-5" type="primary" @click="updateWorkListBaseConfig"
        >确定</Button
      >
      <Button @click="cancelEdit">重置</Button>
      <div></div>
    </div>

    <div class="listenList">
      <div class="left">
        <div style="display: flex; justify-content: space-between">
          <div class="tit">
            <div class="line"></div>
            模板参数
            <Poptip
              content="参照设备说明书填写对应的字符串"
              placement="right"
          
              trigger="hover"
              style="margin-left: 10px"
            >
              <Icon type="md-alert" />
            </Poptip>
          </div>
          <div
            @click="showPage('showPoint1')"
            style="cursor: pointer; color: #338bff"
          >
            {{ showPoint1 ? "收起" : "展开" }}
          </div>
        </div>
        <div class="contain" v-if="showPoint1">
          <Form :label-width="100" inline>
            <FormItem
              v-for="(item, index) in columns"
              :key="index"
              :label="item.title"
              v-if="item.show"
              style="width: 32%"
            >
              <Input
                placeholder="请输入"
                v-model="tempParams[item.key]"
                clearable
                style="width: 150px"
              ></Input>
              <Poptip
                :content="item.remark"
                placement="top"
                class="tip"
                v-show="item.remark"
                trigger="hover"
              >
                <div>!</div>
              </Poptip>
            </FormItem>
          </Form>
        </div>
        <div class="btnGroup" v-if="showPoint1">
          <Button class="cancel" @click="clear()">重置</Button>
          <Button type="primary" @click="saveTempData(1)">{{ btnName }}</Button>
        </div>
      </div>
      <div class="right" v-if="showPoint1">
        <div class="tit">
          <div class="line"></div>
          模板列表
        </div>
        <Table :columns="columns" border :data="TempItemsData">
          <template slot="operation" slot-scope="text, record, index">
            <span class="table-btn">编辑</span>
            <span class="table-btn">删除</span>
          </template>
        </Table>
      </div>
    </div>
    <div class="listenList">
      <div class="left">
        <div style="display: flex; justify-content: space-between">
          <div class="tit">
            <div class="line"></div>
            节点参数
          </div>
          <div
            @click="showPage('showPoint2')"
            style="cursor: pointer; color: #338bff"
          >
            {{ showPoint2 ? "收起" : "展开" }}
          </div>
        </div>
        <div class="contain" v-if="showPoint2">
          <Form :label-width="100" inline>
            <FormItem label="AE应用标识">
              <Input
                placeholder="请输入"
                v-model="pointTemp.AE"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="机房名称">
              <Input
                placeholder="请输入"
                v-model="pointTemp.ExamRoom"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="检查类型(RIS系统)">
              <Input
                placeholder="请输入"
                v-model="pointTemp.RISModality"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="模板名称">
              <Input
                placeholder="请输入"
                v-model="pointTemp.Fields"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="医院编码">
              <Input
                placeholder="请输入"
                v-model="pointTemp.HospitalCode"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="节点名称">
              <Input
                placeholder="请输入"
                v-model="pointTemp.name"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="检查类型(设备)">
              <Input
                placeholder="请输入"
                v-model="pointTemp.Modality"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="字符编码">
              <Input
                placeholder="请输入"
                v-model="pointTemp.Code"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="查询时间区间(天)">
              <Input
                placeholder="请输入"
                v-model="pointTemp.Day"
                clearable
              ></Input>
            </FormItem>
          </Form>
        </div>
        <div class="btnGroup" v-if="showPoint2">
          <Button class="cancel" @click="clear">重置</Button>
          <Button type="primary" @click="savePoint">{{ btnConName }}</Button>
        </div>
      </div>
      <div class="right" v-if="showPoint2">
        <div class="tit">
          <div class="line"></div>
          节点列表
        </div>
        <Table
          border
          highlight-row
          :columns="columns2"
          :data="ConditionListData"
        ></Table>
      </div>
    </div>
    <div class="listenList">
      <div class="left">
        <div style="display: flex; justify-content: space-between">
          <div class="tit">
            <div class="line"></div>
            监听参数
          </div>
          <div
            @click="showPage('showPoint3')"
            style="cursor: pointer; color: #338bff"
          >
            {{ showPoint3 ? "收起" : "展开" }}
          </div>
        </div>
        <div class="contain" v-if="showPoint3">
          <Form :label-width="90" inline>
            <FormItem label="本机IP">
              <Input
                placeholder="请输入"
                v-model="params.IPAddress"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="本机端口">
              <Input
                placeholder="请输入"
                v-model="params.Port"
                clearable
              ></Input>
            </FormItem>
            <!-- <FormItem label="本地AE">
              <Input placeholder="请输入" v-model="params.AE" clearable></Input>
            </FormItem> -->
            <!-- <FormItem label="监听状态">
              <Radio-group v-model="params.IsEnable">
                <Radio :label="'1'">开</Radio>
                <Radio :label="'0'">关</Radio>
              </Radio-group>
            </FormItem> -->
          </Form>
        </div>
        <div class="btnGroup" v-if="showPoint3">
          <Button class="cancel" @click="clear(3)">重置</Button>
          <Button type="primary" @click="saveServer">{{ btnLisName }}</Button>
        </div>
      </div>
      <div class="right" v-if="showPoint3">
        <div class="tit">
          <div class="line"></div>
          监听列表
        </div>
        <Table
          border
          highlight-row
          :columns="columns3"
          :data="ServerList"
        ></Table>
      </div>
    </div>
    <Modal
      v-model="showLog"
      title="WorkList服务日志"
      :footer-hide="true"
      :width="1000"
    >
      <log v-if="showLog" @close="showLog = false" :from="'worklist'"></log>
    </Modal>
  </div>
</template>
<script>
import log from "./log.vue";
export default {
  components: { log },
  data() {
    return {
      timer: null,
      Status: null,
      LogsData: [],
      baseData: {},
      oldBaseData: {},
      // oldApiAddress:'',
      // webAPIAddress:'',
      JIEdianIndex: null,
      MuBanEditIndex: null,
      serviceSign: "",
      isOpen: false,
      showLog: false,
      result: {},
      tempParams: {},
      pointTemp: {},
      params: {
        IsEnable: "0",
      },
      columns: [],
      columns2: [
        {
          title: "AE应用标识",
          width: 150,
          key: "AE",
        },
        {
          title: "节点名称",
          width: 150,
          key: "name",
        },
        {
          title: "机房名称",
          width: 150,
          key: "ExamRoom",
        },
        {
          title: "检查类型(设备)",
          width: 150,
          key: "Modality",
        },
        {
          title: "检查类型(RIS系统)",
          width: 150,
          key: "RISModality",
        },
        {
          title: "字符编码",
          width: 150,
          key: "Code",
        },
        {
          title: "模板名称",
          width: 150,
          key: "Fields",
        },
        {
          title: "查询时间区间(天)",
          width: 150,
          key: "Day",
        },
        {
          title: "医院编码",
          width: 150,
          key: "HospitalCode",
        },
        {
          title: "操作",
          width: "260px",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.editHandle(2, params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.deleteHandle(2, params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      columns3: [
        {
          title: "本机IP",
          key: "IPAddress",
        },
        {
          title: "本地AE",
          key: "AE",
        },
        {
          title: "本机端口",
          key: "Port",
        },
        // {
        //   title: '监听状态',
        //   key: 'IsEnable',
        //   render:(h,params) => {
        //     return h("div", [
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "text",
        //             size: "small",
        //           },
        //           style: {
        //             marginRight: "5px",
        //           },
        //           on: {
        //             click: () => {
        //               this.editHandle(3, params.row);
        //             },
        //           },
        //         },
        //         params.row.IsEnable=='0'?'关闭':'开'
        //       )])
        //   }
        // },
        {
          title: "操作",
          width: "260px",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.editHandle(3, params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.deleteHandle(3, params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      TempItemsData: [],
      ConditionListData: [],
      ServerList: [],
      status: 10,
      btnName: "新增",
      btnConName: "新增",
      btnLisName: "新增",
      showPoint1: true,
      showPoint2: false,
      showPoint3: false,
    };
  },
  methods: {
    updateWorkListBaseConfig() {
      this.$api
        .post("/dictionary/updateWorkListBaseConfig", {
          ...this.baseData,
          printSql: this.baseData.printSql == 1 ? true : false,
        })
        .then((res) => {
          if (res.statusCode == "200") {
            this.$Message.success(res.msg);
            this.getWorkListBaseConfig();
          }
        });
    },
    cancelEdit() {
      // this.baseData = this.oldBaseData;
      // this.baseData.printSql = this.baseData.printSql ? 1 : 0;
      this.getWorkListBaseConfig()
    },
    getWorkListBaseConfig() {
      this.$api.get("dictionary/getWorkListBaseConfig").then((res) => {
        //console.log('-------------------',res);
        this.baseData = res.data;
        this.baseData.printSql = this.baseData.printSql ? 1 : 0;
        this.oldBaseData = JSON.parse(JSON.stringify(this.baseData));
        console.log(this.baseData);
      });
    },

    // editwebAPIAddress(){
    //     this.$api.get('dictionary/webAPIAddress',{
    //       webAPIAddress:this.webAPIAddress
    //     }).then((res) => {
    //       if(res.statusCode=='200'){
    //           this.oldApiAddress = this.webAPIAddress
    //           this.$Message.success('修改成功')
    //       }
    //     console.log('Address', res);
    //   })
    // },
    // cancelEdit(){
    //   this.webAPIAddress=this.oldApiAddress
    // },
    getwebAPIAddress() {
      this.$api.get("dictionary/getwebAPIAddress").then((res) => {
        this.oldApiAddress = res.data;
        this.webAPIAddress = res.data;
        console.log("Address", res);
      });
    },
    showPage(type) {
      this[type] = !this[type];
      var arr = ["showPoint1", "showPoint2", "showPoint3"];
      if (this[type]) {
        arr.forEach((item) => {
          if (item != type) {
            this[item] = false;
          }
        });
      }
      if (type == "showPoint2" && this[type]) {
        this.getConditionList();
      }
      if (type == "showPoint3" && this[type]) {
        this.getServerList();
      }
    },
    changeSwitch(val) {
      this.isOpen = val;
      this.$api
        .post("dictionary/updateServiceStatus", {
          serviceSign: this.serviceSign,
          serviceStatus: this.isOpen,
        })
        .then((res) => {
          if (!res) {
            this.isOpen = !this.isOpen;
            this.Status = this.result.serviceStatus;
            this.timer = setInterval(() => {
              this.getServiceInfo();
            }, 10000);
          } else {
            this.getServiceInfo();
          }
        });
    },
    clear(type) {
      if (type == 1) {
        this.btnName = "新增";
        this.columns.forEach((item) => {
          this.tempParams[item.key] = null;
        });
        this.getTempItems();
      } else if (type == 2) {
        this.btnConName = "新增";
        this.pointTemp = {};
        this.getConditionList();
      } else {
        this.btnLisName = "新增";
        this.params = {
          IsEnable: "0",
        };
        this.getServerList();
      }
    },
    containsDuplicate(arr) {
      let temp = {};
      for (let i = 0; i < arr.length; i++) {
        if (temp[arr[i]]) {
          return true;
        } else {
          temp[arr[i]] = 1;
        }
      }
      return false;
    },
    saveServer() {
      if (this.btnLisName == "保存") {
        //编辑
        this.ServerList.splice(this.params._index, 1);
        this.ServerList.push(this.params);
        let arr = this.ServerList.map((item) => {
          return item.IPAddress + item.Port;
        });
        // console.log('--++++++',this.containsDuplicate(arr));
        if (this.containsDuplicate(arr)) {
          this.$Message.warning("同域名下不能监听同一端口");
          this.clear(3);
          return;
        }

        this.$api
          .post(`dictionary/AddOrEditServerList`, {
            serverList: this.ServerList,
          })
          .then((res) => {
            this.clear(3);
          });
      } else {
        //新增

        console.log(this.ServerList, 888);
        this.ServerList.push(this.params);
        let arr = this.ServerList.map((item) => {
          return item.IPAddress + item.Port;
        });
        // console.log('--++++++',this.containsDuplicate(arr));
        if (this.containsDuplicate(arr)) {
          this.$Message.warning("同域名下不能监听同一端口");
          this.clear(3);
          return;
        }
        this.$api
          .post(`dictionary/AddOrEditServerList`, {
            serverList: this.ServerList,
          })
          .then((res) => {
            this.clear(3);
          });
      }
    },
    savePoint() {
      if (this.btnConName == "保存") {
        //新增
        if (!this.pointTemp.AE) {
          this.$Message.warning("名称不能为空");
          return;
        }
        let datas = {};
        this.ConditionListData[this.JIEdianIndex] = this.pointTemp;
        this.ConditionListData.forEach((item, index) => {
          let AE = item.AE;
          datas[AE] = item;
        });
        console.log(this.pointTemp);
        this.$api
          .post(`dictionary/AddOrEditConditionList`, { ...datas })
          .then((res) => {
            if (res.statusCode == "200") {
              this.$Message.success(res.msg);
            }
            this.clear(2);
          });
      } else {
        //新增
        if (!this.pointTemp.AE) {
          this.$Message.warning("名称不能为空");
          return;
        }
        let datas = {};
        this.ConditionListData.push(JSON.parse(JSON.stringify(this.pointTemp)));
        this.ConditionListData.forEach((item, index) => {
          let AE = item.AE;
          datas[AE] = item;
        });
        console.log(this.pointTemp);
        this.$api
          .post(`dictionary/AddOrEditConditionList`, { ...datas })
          .then((res) => {
            this.clear(2);
          });
      }
    },
    saveTempData() {
      if (this.btnName == "保存") {
        if (!this.tempParams.name) {
          this.$Message.warning("名称不能为空");
          return;
        }
        //编辑
        let datas = {};
        this.TempItemsData[this.MuBanEditIndex] = this.tempParams;
        this.TempItemsData.forEach((item, index) => {
          let name = item.name;
          datas[name] = item;
        });
        console.log("datadatadata", datas);
        this.$api
          .post(`dictionary/AddOrEditTempItems`, { ...datas })
          .then((res) => {
            if (res.statusCode == "200") {
              this.$Message.success(res.msg);
            }
            console.log(res);
            this.clear(1);
          });
      } else {
        //新增
        if (!this.tempParams.name) {
          this.$Message.warning("名称不能为空");
          return;
        }
        this.TempItemsData.push(JSON.parse(JSON.stringify(this.tempParams)));
        let datas = {};
        this.TempItemsData.forEach((item, index) => {
          let name = item.name;
          datas[name] = item;
        });
        console.log("datadatadata");

        this.$api
          .post(`dictionary/AddOrEditTempItems`, { ...datas })
          .then((res) => {
            console.log(res);
            this.clear(1);
          });
      }
    },
    refresh() {
      this.getServiceInfo();
      this.getTempData();
    },
    getTempData() {
      this.$api
        .get(`dictionary/getDictionaryListByCategroyCode`, {
          categroyCode: "work",
        })
        .then((res) => {
          console.log("----", res);
          var templateList = res.data.map((item) => {
            return {
              title: item.dictionaryValue || "",
              key: item.dictionaryCode,
              remark: item.extend01,
              width: 150,
              show: true,
            };
          });
          this.columns = [
            {
              title: "模板名称",
              key: "name",
              width: 100,
              show: true,
            },
            ...templateList,
            {
              title: "操作",
              width: "260px",
              align: "center",
              show: false,
              render: (h, params) => {
                return h("div", [
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                        color: "#3795C8",
                      },
                      on: {
                        click: () => {
                          this.editHandle(1, params.row);
                        },
                      },
                    },
                    "编辑"
                  ),
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                        color: "#3795C8",
                      },
                      on: {
                        click: () => {
                          this.deleteHandle(1, params.row);
                        },
                      },
                    },
                    "删除"
                  ),
                ]);
              },
            },
          ];
          this.columns.forEach((item) => {
            this.tempParams[item.key] = "";
          });
          this.getTempItems();
        });
    },
    getServiceInfo() {
      this.$api
        .get(`dictionary/getServiceInfo`, { serviceSign: "ProcessWorkList" })
        .then((res) => {
          this.serviceSign = res.data.serviceSign;
          this.result = res.data;
          if (this.Status !== res.data.serviceStatus) {
            clearInterval(this.timer);
          }
          this.isOpen = res.data.serviceStatus === 10;
        });
    },
    getTempItems() {
      this.$api
        .get(`dictionary/getTempItems`, { serviceSign: "ProcessWorkList" })
        .then((res) => {
          console.log("--------", res);
          this.TempItemsData = Object.keys(res.data).map((item) => {
            return res.data[item];
          });
          console.log("--table-----", this.TempItemsData);
        });
    },
    deleteHandle(type, data) {
      this.$Modal.confirm({
        title: "确认要删除么？",
        mask: false,
        onOk: () => {
          if (type == 1) {
            this.$api
              .post(`dictionary/deleteTempItems`, {
                serviceSign: "ProcessWorkList",
                name: data.name,
              })
              .then((res) => {
                this.clear(type);
              });
          } else if (type == 2) {
            console.log(data);
            this.$api
              .post(`dictionary/deleteConditionList`, {
                serviceSign: "ProcessWorkList",
                name: data.AE,
              })
              .then((res) => {
                this.clear(type);
              });
          } else {
            this.ServerList.splice(this.params._index, 1);
            this.$api
              .post(`dictionary/AddOrEditServerList`, {
                serverList: this.ServerList,
              })
              .then((res) => {
                if (res.statusCode == "200") {
                  this.$Message.success(res.msg);
                }
                this.clear(type);
              });
          }
        },
      });
    },
    editHandle(type, data) {
      // console.log('---------',type);
      if (type == 1) {
        this.MuBanEditIndex = data._index;
        this.btnName = "保存";
        this.tempParams = Object.assign({}, data);
      } else if (type == 2) {
        console.log(data._index);
        this.JIEdianIndex = data._index;
        this.btnConName = "保存";
        this.pointTemp = Object.assign({}, data);
      } else {
        this.btnLisName = "保存";
        this.params = Object.assign({}, data);
        this.$set(this.params, this.params);
      }
    },
    getConditionList() {
      this.$api
        .get(`dictionary/getConditionList`, { serviceSign: "ProcessWorkList" })
        .then((res) => {
          this.ConditionListData = Object.keys(res.data).map((item) => {
            return res.data[item];
          });
        });
    },
    getServerList() {
      this.$api
        .get(`dictionary/getServerList`, { serviceSign: "ProcessWorkList" })
        .then((res) => {
          console.log(res);
          this.ServerList = res.data;
        });
    },
  },
  created() {
    this.LogsData = this.$parent.LogsData;
  },
  mounted() {
    this.getWorkListBaseConfig();
    // this.getwebAPIAddress()
    this.getServiceInfo();
    this.getTempData();
  },
};
</script>
<style>
.scpPage .ivu-poptip-body-content-inner {
  color: #ff4d4f;
}
.scpPage .ivu-poptip-inner {
  width: 150px !important;
  word-break: break-all !important;
  white-space: initial !important;
}
.scpPage .ivu-poptip-body-content {
  overflow-x: hidden;
}
</style>
<style scoped lang="scss">
.scpPage {
  color: #333;
  .tip {
    width: 14px;
    height: 14px;
    line-height: 14px;
    font-size: 12px;
    background-color: #dcdcdc;
    border-radius: 50%;
    text-align: center;
    margin: 0 0 0 12px;
    cursor: pointer;
  }
  .operation {
    display: flex;
    justify-content: space-between;
    .status {
      width: 74px;
      height: 74px;
      background: rgba(0, 168, 112, 0.1);
      border-radius: 50%;
      font-size: 18px;
      font-weight: 400;
      color: #00a870;
      line-height: 74px;
      text-align: center;
    }
  }
  .line {
    width: 4px;
    height: 18px;
    background: #338bff;
    margin: 0 8px 0 0;
  }
  .first {
    display: flex;
    justify-content: space-between;
    margin: 16px 0 12px 0;
    height: 32px;
    line-height: 32px;
    .tit {
      display: flex;
      align-items: center;
      font-size: 16px;
    }
    .log {
      width: 82px;
      text-align: center;
      background: #f2f7ff;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: #338bff;
      cursor: pointer;
    }
  }
  .des {
    display: flex;
    border: 1px solid #e5e5e5;
    padding: 18px 12px;
    .serDes {
      margin: 0 24px 0 0;
    }
    .secondTit {
      color: #666666;
    }
  }
  .listenList {
    .tit {
      display: flex;
    }
    .left {
      margin: 16px 16px 0 0;
      .contain {
        border: 1px solid #dcdcdc;
        padding: 12px;
        margin: 12px 0 0 0;
      }
      .btnGroup {
        display: flex;
        justify-content: flex-end;
        margin: 12px 0 16px 0;
        .cancel {
          margin: 0 12px 0 0;
        }
      }
    }
    .right {
      margin: 16px 0 24px 0;
      .tit {
        margin: 0 0 16px 0;
      }
      .tip {
        font-size: 10px;
        font-weight: 400;
        color: #ff4d4f;
      }
    }
  }
}
/deep/ .ivu-input-number {
  width: 180px;
}
</style>
<style>
.scpPage .ivu-form-item {
  margin-bottom: 12px;
}
</style>